import JobBasicInfo from '@/components/JobBasicInfo';
import JobBenefitsAndPerks from '@/components/JobBenefitsAndPerks';
import SectionBox from '@/components/SectionBox';
import TextEditor from '@/components/TextEditor';
import { EditableJobProps } from '@/types';
import { Job } from '@/types/api';
import * as Styles from './JobDetails.styles';

type JobDetailsComponentProps = Pick<
  EditableJobProps,
  | 'workingTimes'
  | 'updatedField'
  | 'onSubmit'
  | 'setUpdatedField'
  | 'handleChangeWorkingTimes'
  | 'onAddNewWorkingTime'
> & {
  job: Job;
  onSaveText: (field: string, value: string) => Promise<void>;
  onSelectBenefit: (benefitIds: string[]) => Promise<void>;
  onScrollTo: (elementId: string) => void;
};

const JobDetailsComponent = function ({
  job,
  workingTimes,
  onScrollTo,
  updatedField,
  onSubmit,
  setUpdatedField,
  handleChangeWorkingTimes,
  onAddNewWorkingTime,
  onSaveText,
  onSelectBenefit,
}: JobDetailsComponentProps): JSX.Element {
  const sidebarMenus = [
    {
      label: 'Basic Info',
      id: 'sidebar-basic-info',
      onClick: () => onScrollTo('basic-info'),
    },
    {
      label: 'Description',
      id: 'sidebar-description',
      onClick: () => onScrollTo('description'),
    },
    {
      label: 'Requirements',
      id: 'sidebar-requirements',
      onClick: () => onScrollTo('requirements'),
    },
    {
      label: 'Benefits & Perks',
      id: 'sidebar-benefits-perks',
      onClick: () => onScrollTo('benefits-perks'),
    },
  ];

  return (
    <div data-testid="job-details-page" className="tw-pt-4">
      <Styles.PageGrid>
        <Styles.Sidebar testId="job-sidebar" sidebarMenus={sidebarMenus} />
        <Styles.Content>
          <JobBasicInfo
            job={job}
            workingTimes={workingTimes}
            handleChangeWorkingTimes={handleChangeWorkingTimes}
            onAddNewWorkingTime={onAddNewWorkingTime}
            updatedField={updatedField}
            onSubmit={onSubmit}
            setUpdatedField={setUpdatedField}
          />

          <SectionBox title="Description" id="description">
            <TextEditor
              onSaveText={(value) => onSaveText('description', value)}
              value={job.description ?? ''}
            />
          </SectionBox>

          <SectionBox title="Requirements" id="requirements">
            <TextEditor
              onSaveText={(value) => onSaveText('requirements', value)}
              value={job.requirements ?? ''}
            />
          </SectionBox>

          <JobBenefitsAndPerks selectedBenefits={job.benefits} onSelectBenefit={onSelectBenefit} />
        </Styles.Content>
      </Styles.PageGrid>
    </div>
  );
};

export default JobDetailsComponent;
